export default "__VITE_ASSET__BIFYJKtN__"